<!--
============================================================================
MIGRATION-AUTOMATION: VUE3-COMPONENT-BMW-ROTATIONAL-BANNERS
This is the BMW-specific rotational banner component for Vue3 only.
If updating this file, ensure all BMW-specific logic and UI conventions are preserved.
This file is not used in the Vue2 application.
Vue2 file: Velocity.PrimaryOffersites.Web/wwwroot/js/components/RotationalBanner/BmwRotationalbanners.vue
Any clarifications contact Leela Directly.
============================================================================
COMPONENT: BmwRotationalbanners (Vue3)
- BMW-specific implementation of the rotational banner carousel.
- Handles both image and Evox media banners, mobile/desktop logic, and disclaimer modal.
- Uses vue-carousel, v-lazy-image, and EvoxMediaRotationalBanner.
- Banner data is fetched from API and filtered for validity.
- Includes custom progress indicator, navigation, and analytics integrations.
- All BMW-specific UI/UX and business logic must be preserved in this file.
- For migration/refactor, follow automation/migration conventions in upgrade-notes.md.
============================================================================
-->

<template>
  <div class="rotational-banner-component bw-rotational-banner">
    <div
      v-if="bannersdata.length"
      id="rotaional-carousel"
      :data-count="vehicleCount"
      class="rotational-banners position-relative"
      :style="cssVars"
    >
      <SlickCarousel :config="carouselConfigObject" :slotIds="slotIds" @slideChange="onSlideChange">
        <template v-for="banner in bannersdata" v-slot:[`slide-${banner.bannerId}`]>
          <div v-if="findBannerType(banner)" :key="banner.bannerId" class="h-100">
            <a
              v-if="baseUrl + banner.url"
              :href="getUrl(banner)"
              :target="getTarget(banner)"
              class="d-block position-relative banner-wrapper"
              @click.prevent="openBindEvent(banner)"
            >
              <LazyImageWrapper
                v-if="!ismobile && banner.imageUrl"
                :src="banner.imageUrl + `&type=webp&quality=${bannerQuality}`"
                :loading="banner.imageUrl + '&type=webp&quality=6'"
                :classes="'w-100'"
                :alt="banner.altText"
              />
              <template v-if="ismobile && banner.mobileImageUrl">
                <LazyImageWrapper
                  v-if="websitesDomain && isLandingPage && applySpeedValues"
                  :src="getMobileImageUrl(banner.mobileImageUrl)"
                  :classes="'set-aspect-ratio'"
                  :width="deviceWidth"
                  :height="deviceHeight"
                  :alt="banner.altText"
                />
                <LazyImageWrapper
                  v-else
                  :src="banner.mobileImageUrl + '&type=webp&quality=95'"
                  :classes="'set-aspect-ratio w-100'"
                  :alt="banner.altText"
                />
              </template>
            </a>
          </div>
          <div v-else :key="`${banner.bannerId}`" class="h-100">
            <a
              v-if="baseUrl + banner.url"
              :href="getUrl(banner)"
              :target="getTarget(banner)"
              class="d-block position-relative banner-wrapper"
              :style="[setClassForAutoBanner(banner)]"
              @click.prevent="openBindEvent(banner)"
            >
              <template v-if="getBannerBgType(banner)">
                <LazyImageWrapper
                  v-if="!ismobile && banner.imageUrl"
                  :src="banner.imageUrl + `&type=webp&quality=${bannerQuality}`"
                  :loading="banner.imageUrl + '&type=webp&quality=6'"
                  :classes="'w-100'"
                  :alt="banner.altText"
                />
                <template v-if="ismobile && banner.mobileImageUrl">
                  <LazyImageWrapper
                    v-if="websitesDomain && isLandingPage && applySpeedValues"
                    :src="getMobileImageUrl(banner.mobileImageUrl)"
                    :classes="'set-aspect-ratio'"
                    :width="deviceWidth"
                    :height="deviceHeight"
                    :alt="banner.altText"
                  />
                  <LazyImageWrapper
                    v-else
                    :src="banner.mobileImageUrl + '&type=webp&quality=95'"
                    :classes="'set-aspect-ratio w-100'"
                    :alt="banner.altText"
                  />
                </template>
              </template>
              <evox-media-rotational-banner
                v-if="
                  banner.rotationalBannerType &&
                  banner.rotationalBannerType.toLowerCase() !== 'image'
                "
                :callForPriceDetails="callForPriceDetails"
                :bannerdata="banner"
                :class="[render, noBannerWithBgImage ? 'noBannerWithBgImage' : '']"
                @show-Offer-Disclaimer="openDisclaimer"
              />
            </a>
          </div>
        </template> 
      </SlickCarousel>
      <div v-if="hideBannerControl" class="carousel-list-items mx-4">
        <div>
          <div class="row">
            <div class="col-12 animation-wrapper">
              <div
                v-for="(slickItem, slickIndex) in slickListItems"
                :key="slickIndex"
                v-if="showSliderCount"
                class="d-inline-block slide-count"
              >
                <div
                  v-if="slickIndex == currentSlide"
                  class="d-inline-block px-2 slickActive"
                  @click="pausePlaySlick(currentActive, slickIndex)"
                >
                  <div v-if="currentActive" class="progress blue">
                    <span class="progress-left">
                      <span
                        v-if="slickIndex == currentSlide"
                        :id="'leftProgress-' + currentSlide"
                        class="progress-bar"
                        :style="circleProgress(currentSlide)"
                      />
                    </span>
                    <span class="progress-right">
                      <span
                        v-if="slickIndex == currentSlide"
                        :id="'rightProgress-' + currentSlide"
                        class="progress-bar"
                        :style="circleProgress(currentSlide)"
                      />
                    </span>
                    <div class="progress-value" :style="{ color: controlscolor }">
                      <span class="primaryicon-pause-regular" />
                    </div>
                  </div>
                  <div v-else class="progress">
                    <span class="progress-left">
                      <span class="progress-bar" />
                    </span>
                    <span class="progress-right">
                      <span class="progress-bar" />
                    </span>
                    <div class="progress-value" :style="{ color: controlscolor }">
                      <span class="primaryicon-play-filled" />
                    </div>
                  </div>
                </div>
                <div
                  v-else
                  class="d-inline-block px-2"
                  style="cursor: pointer"
                  :style="{ color: controlscolor }"
                  @click.prevent="goTo(slickIndex + 1)"
                >
                  {{ slickIndex + 1 }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <a
        id="btn-details"
        v-if="checkDisclaimer()"
        :class="[
          getDisclaimerPosition(),
          'bgcolor-primary font-weight-bold _msbi_background_color px-1 px-sm-2 no-hover text-center py-1 py-sm-2 position-absolute text-white rounded-buttons btn-view-details cursor-pointer',
        ]"
        style="position: absolute; z-index: 7"
        @click.prevent="onDisclaimerClick()"
      >
        <i
          :class="[
            getDisclaimerPosition() === 'banner-view-details-top' ? '' : 'primaryicon-info',
            'mr-1 mr-sm-2',
          ]"
          aria-hidden="true"
        />{{ getDisclaimerLabel() }}
      </a>
    </div>
  </div>
</template>

<script>
import SlickCarousel from "../../Shared/SlickCarousel/SlickCarousel.vue";
import LazyImageWrapper from "../../Shared/LazyImageWrapper/LazyImageWrapper.vue";
import { TagManagerContainer } from "../../../Events/GoogleTagManager/TagManagerContainer";

import axios from "axios";
import ShiftDigitalContainer from "../../../Events/ShiftDigital/ShiftDigitalContainer";
import ShiftDigitalService from "../../../Events/ShiftDigital/ShiftDigitalService";
import { SHIFT_DIGITAL_IMAGE_ROTATIONAL_CAROUSEL_ASSET_NAME } from "@/js/services/ShiftDigital/ShiftDigitalConstants";
import { fireSonicCarouselBannerClick } from "../../../Events/SonicDataLayer/sonicDataService";
import {
  fireTagMediaInteractionEvent,
  onCommonCarouselArrowClick,
  onCommonLinkLogs,
} from "../../../Events/TagManagerServices/TaggingEventForPages";
import EvoxMediaRotationalBanner from "../../EvoxMediaRotationalBanner/EvoxMediaRotationalBanner.vue";

import RotationalBannerMixin from "@/js/components/RotationalBanner/RotationalBannerMixin";
import { onModalLinkClick } from "@/js/services/CommonUtility";
import { mapWritableState } from "pinia";
import { useBannersDataStore } from "../../../store/BannersDataStore/BannersDataStore";

import { useTextModalStore } from "../../../store/Shared/TextModalStore/TextModalStore";

export default {
  components: {
    SlickCarousel,
    LazyImageWrapper,
    // "disclaimer-modal": Disclaimermodal,
    EvoxMediaRotationalBanner,
  },
  mixins: [RotationalBannerMixin],
  props: {
    sectionid: {
      required: true,
    },
    hidearrows: {
      required: false,
      default: false,
    },
    hidecontrols: {
      required: false,
      default: false,
    },
    controlscolor: {
      type: String,
      default: "",
    },
    applySpeedValues: {
      required: false,
      default: false,
      type: Boolean,
    },
  },
  data() {
    return {
      carouselConfigObject: {
        wrapAround: true,
        autoplay: 0
      },
      slotIds: [],
      showSliderCount: false,
      showdisclaimermodal: false,
      disclaimertext: "",
      shiftDigital: "",
      currentSlide: 0,
      slide: 0,
      sliding: null,
      searchtype: "new",
      searchkey: "",
      baseUrl: window.baseUrl,
      bannersdata: [],
      searchdata: "",
      vehiclesdata: [],
      ismobile: window.ismobile,
      // bannerTimmer: 0,
      // bannerautoplay: false,
      slickListItems: [],
      currentActive: true,
      currentPage: 0,
      bannerTimmerProgress: "15s",
      hideBannerControl: false,
      deviceWidth: "100%",
      deviceHeight: "auto",
      isLandingPage: window.location.pathname === "/",
      websitesDomain: typeof window.websitesDomain !== "undefined" ? window.websitesDomain : false,
      // bannerControlsWidth: "",
      callForPriceDetails: [],
    };
  },
  computed: {
    cssVars() {
      return {
        "--bg-color": window.primaryColor,
      };
    },
    vehicleCount() {
      return this.bannersdata ? this.bannersdata.length : 0;
    },
    ...mapWritableState(useBannersDataStore, {
      rotationalBannersData: "rotationalBannersData",
    }),
    ...mapWritableState(useTextModalStore, {
      showTextModal: "showTextModal",
      textModalTitle: "title",
      textModalText: "text",
    }),
  },
  watch: {
    currentSlide() {
      this.checkDisclaimer(this.currentSlide);
      setInterval(() => {
        this.circleProgress(this.currentSlide);
      }, 800);
    },
  },
  mounted() {
    this.getImagesWidthHeight();
    this.shiftDigital = ShiftDigitalContainer.getShiftDigitalObject();
    console.log(this.hidearrows);
    if (this.hidecontrols === "True") {
      this.hideBannerControl = false;
    } else {
      this.hideBannerControl = true;
    }
    let bannerUrl = this.frameBannerAPIUrl(
      `${window.ApiBaseUrl}/Landing/GetRotationBanners?sectionId=${this.sectionid}&campaignId=${window.campaignId}&accountId=${window.accountId}`
    );

    axios.get(bannerUrl).then((response) => {
      try {
        let imageDummy = document.querySelector("#rotational-image-dummy");
        imageDummy?.remove();
      } catch (e) {
        console.log(e);
      }
      let bannerResponse = response.data.rotationalBanners;

      this.bannersdata = this.filterOfferIsValid(bannerResponse);
      this.bannersdata = this.filterEmptyBanner(this.bannersdata, this.ismobile);
      this.rotationalBannersData = this.bannersdata;
      this.slotIds = this.bannersdata.map((banner) => {
        return "slide-" + banner.bannerId;
      });

      if (window.isConquestProfileEnabled && this.bannersdata?.length) {
        this.conquestProfileLogic(this.bannersdata);
      }

      if (this.bannersdata.length > 1) {
        this.showSliderCount = true;
      }
      for (let i = 0; i < this.bannersdata.length; i++) {
        this.slickListItems.push(i);
      }
      this.searchdata = response.data.searchComponentDto;
      this.callForPriceDetails = response.data.bannerCampaignDto;
      // setTimeout(() => {
      //   if (this.ismobile) {
      //     try {g

      //       let bannerHeight = document.getElementById("rotaional-carousel").offsetHeight;
      //       if (bannerHeight) {
      //         document.getElementsByClassName("landingpageiframe")[0].style.minHeight =
      //           bannerHeight + "px";
      //       }
      //     } catch (e) {
      //       console.log(e);
      //     }
      //   }
      //   // document.querySelectorAll(".arrow-fire").forEach((item) => {
      //   //   item.addEventListener("click", () => {
      //   //     setTimeout(() => {
      //   //       this.onPageChangeEvent();
      //   //     }, 100);
      //   //   });
      //   // }
      //   // );
      // }, 200);
    });
    if (window.rotatingBannerDelayTime !== null && window.rotatingBannerDelayTime !== 0) {
      this.carouselConfigObject.autoplay = window.rotatingBannerDelayTime * 1000;
      this.bannerTimmerProgress = window.rotatingBannerDelayTime;
      // this.bannerautoplay = true;
    }
    const couponInterval = setInterval(() => {
      if (document.querySelector(".VueCarousel-navigation-button .primaryicon-left-arrow")) {
        clearInterval(couponInterval);
        document
          .querySelector(".VueCarousel-navigation-button .primaryicon-left-arrow")
          .addEventListener("click", this.bannerBackClick);
        document
          .querySelector(".VueCarousel-navigation-button .primaryicon-right-arrow")
          .addEventListener("click", this.bannerForwardClick);
      }
    }, 200);
  },
  methods: {
    openDisclaimer(data) {
      this.textModalTitle = "Disclosure";
      this.textModalText = data;
      this.showTextModal = true;
    },
    getMobileImageUrl(url) {
      let imageUrl = url + "&type=webp&quality=95";
      if (window.location.pathname !== "/") {
        return imageUrl;
      }

      try {
        if (typeof window.websitesDomain !== "undefined" && window.websitesDomain) {
          imageUrl = url + "&type=webp&quality=95";
          if (imageUrl.includes("&Width=0")) {
            imageUrl = imageUrl.replace("&Width=0", "");
          }
          if (imageUrl.includes("&Height=0")) {
            imageUrl = imageUrl.replace("&Height=0", "");
          }
        }
      } catch (e) {
        console.log(e);
      }

      return imageUrl;
    },
    getImagesWidthHeight() {
      if (window.location.pathname === "/") {
        if (
          typeof window.websitesDomain !== "undefined" &&
          window.websitesDomain &&
          this.applySpeedValues
        ) {
          this.deviceWidth = window.rotationalBannerWidth;
          this.deviceHeight = parseInt(window.rotationalBannerHeight);
        }
      }
    },
    circleProgress() {
      let progressLeft = `leftProgress-${this.currentSlide}`;
      let leftid = document.getElementById(progressLeft);

      if (leftid) {
        leftid.style.animationName = "";
        leftid.style.animationTimingFunction = "";
        leftid.style.animationFillMode = "";
        leftid.style.animationDirection = "";

        let duration = this.bannerTimmerProgress / 2;
        leftid.style.animationName = "loading-2";
        leftid.style.animationDuration = `${duration}` + "s";
        leftid.style.animationTimingFunction = "linear";
        leftid.style.animationDelay = `${duration}` + "s";
        leftid.style.animationFillMode = "forwards";
        leftid.style.animationDirection = "initial";
      }

      let progressRight = `rightProgress-${this.currentSlide}`;
      let rightid = document.getElementById(progressRight);
      if (rightid) {
        let duration = this.bannerTimmerProgress / 2;
        rightid.style.animationName = "";
        rightid.style.animationTimingFunction = "";
        rightid.style.animationFillMode = "";
        rightid.style.animationDirection = "";
        rightid.style.animationName = "loading-1";
        rightid.style.animationDuration = `${duration}` + "s";
        rightid.style.animationTimingFunction = "linear";
        rightid.style.animationFillMode = "forwards";
        rightid.style.animationDirection = "initial";
      }
    },
    goTo(data) {
      let a = data - 1;
      this.currentPage = a;
      this.currentSlide = a;
      onCommonCarouselArrowClick({
        interactionLabel: "bullet",
        interactionValue: `${data} / ${this.slickListItems?.length} `,
      });
    },
    pausePlaySlick(type, slickIndex) {
      this.currentActive = !type;
      if (!this.currentActive) {
        // this.bannerautoplay = false;
        this.carouselConfigObject.autoplay = 0;
      } else {
        // this.bannerautoplay = true;
        this.carouselConfigObject.autoplay = window.rotatingBannerDelayTime * 1000;
      }
      this.currentSlide = slickIndex;
    },
    checkDisclaimer(currentSlide = 0) {
      let flag = false;
      let data = this.bannersdata.filter((item, index) => index === this.currentSlide);
      if (data && data.length > 0 && data[0].disclaimer) {
        flag = true;
      }
      return flag;
    },
    getDisclaimerLabel() {
      let data = this.bannersdata.filter((item, index) => index === this.currentSlide);
      if (data[0] && data[0].disclaimerLabel) {
        return data[0].disclaimerLabel;
      }
      return "Disclosure";
    },
    getDisclaimerPosition() {
      let data = this.bannersdata.filter((item, index) => index === this.currentSlide);
      if (data?.[0]?.disclaimerDesignType?.trim() === "top") {
        return "banner-view-details-top";
      }
      return "banner-view-details";
    },
    onDisclaimerClick() {
      let data = this.bannersdata.filter((item, index) => index === this.currentSlide);
      this.textModaltitle = data[0]?.disclaimerLabel || "Disclosure";
      this.textModalText = data[0]?.disclaimer || "No disclaimer available";
      this.showTextModal = true;
    },
    onSlideChange(slideIndex) {
      console.log("Slide changed to:", slideIndex);
      this.currentSlide = slideIndex;
      // Force reactivity to ensure disclaimer updates
      this.$forceUpdate();
    },
    onPageChange: function (val) {
      this.currentSlide = val;
    },
    onPageChangeEvent() {
      if (this.shiftDigital) {
        const slide = this.currentSlide ? this.currentSlide : 0;
        let carouselClick = {
          "carouselClick.assetPosition": slide + 1,
          "carouselClick.assetName": this.bannersdata?.[slide]?.label
            ? this.bannersdata[slide].label
            : SHIFT_DIGITAL_IMAGE_ROTATIONAL_CAROUSEL_ASSET_NAME,
        };

        ShiftDigitalService.shiftDigitalCarouselClick(this.shiftDigital, carouselClick);
      }
    },
    getTarget(banner) {
      const url = banner.url;
      if (banner.redirectionType) {
        return banner.redirectionType.toLowerCase();
      }
      if (url) {
        if (url.includes("http:") || url.includes("https:")) {
          return "_blank";
        } else {
          return "_self";
        }
      }
      return "_self";
    },
    onSlideStart() {
      this.sliding = true;
      window.dispatchEvent(new Event("scroll"));
    },
    onSlideEnd() {
      this.sliding = false;
    },
    searchVehicle() {
      let url = `${window.ApiBaseUrl}/Inventory/Search?accountId=${window.accountId}&searchkeyword=${this.searchkey}&searchType=${this.searchtype}`;
      if (this.searchtype === "service") {
        url = `${window.ApiBaseUrl}/Offers/searchcoupons?accountid=${window.accountId}&campaignid=${window.campaignId}&strSearch=${this.searchkey}`;
      }
      axios.get(url).then((response) => {
        if (this.searchtype === "service") {
          this.formatService(response.data);
        } else {
          this.formatVehicles(response.data);
        }
      });
    },
    formatService(data) {
      this.vehiclesdata = [];

      data.forEach((val) => {
        let htmldata = `<a href="${window.baseUrl}/specials/servicespecials" class="d-inline-block"><div class="d-flex align-items-center">
                                    <div class="dropdown-text">${val.heading} ${val.subHeading}</div>
                                </div></a>`;
        this.vehiclesdata.push(htmldata);
      });
    },
    onsearchtypeclick(type) {
      this.searchkey = "";
      this.searchtype = type;
      this.vehiclesdata = [];
    },
    formatVehicles(data) {
      this.vehiclesdata = [];

      data.forEach((val) => {
        let htmldata = `<a href="${window.baseUrl}${val.link}" class="d-inline-block"><div class="d-flex align-items-center">
                                    <img src='${val.photoURL}' class='dropdown-image'/>
                                    <div class="dropdown-text">${val.vehcileName}</div>
                                </div></a>`;
        this.vehiclesdata.push(htmldata);
      });
    },
    sliderButton() {
      return `<em class="arrow-fire primaryicon-right-arrow bgcolor-primary _msbi_background_color slick-arrow" style="cursor: pointer; z-index: 1;"></em>`;
    },
    sliderleftButton() {
      return `<div class="bgcolor-primary"><em class="arrow-fire primaryicon-left-arrow slick-arrow" style="color: rgb(204, 204, 204); cursor: pointer; z-index: 1;"></em></div>`;
    },
    logTagClickEvents(label, url, banner) {
      let tagManager = TagManagerContainer.getDealerObject();
      if (tagManager && typeof tagManager.getLinkClickEvent === "function") {
        tagManager.getLinkClickEvent(label, url);
      }
      if (banner) {
        let label = banner.label;
        if (!label) label = banner.altText ? banner.altText : "Banner Image";
        onCommonLinkLogs({ label, url });
      }
    },
    openBindEvent(banner) {
      fireSonicCarouselBannerClick(banner.altText, banner.imageUrl);
      this.onPageChangeEvent();
      this.logTagClickEvents("RotationBanner", banner.url, banner);
      if (banner?.category && banner?.action && banner?.label) {
        logGoogleBingEvent(banner.category, banner.action, banner.label, 1, banner.label);
      }
      fireTagMediaInteractionEvent({
        action: "redirect",
        mediaType: "slider",
        mediaLink: banner.url,
        mediaName: banner.altText,
        adobeNissanNoTagging: true,
        carouselData: {
          assetName: this.bannersdata[this.currentSlide].label,
          assetPosition: this.currentSlide + 1,
        },
      });

      if (banner.url?.includes("#modal")) {
        onModalLinkClick(this.getUrl(banner), this.getTarget(banner));
      } else {
        setTimeout(() => {
          window.open(this.getUrl(banner), this.getTarget(banner));
        }, 200);
      }
    },
    bannerBackClick() {
      const fdEvents = ShiftDigitalContainer.getShiftDigitalObject();
      if (fdEvents && typeof fdEvents.actionsOnHomePage === "function") {
        fdEvents.actionsOnHomePage("carousel scroll:left");
      }
      fireTagMediaInteractionEvent({
        action: "swipe left",
        mediaType: "slider",
        mediaLink: "",
        mediaName: "",
      });
    },
    bannerForwardClick() {
      const fdEvents = ShiftDigitalContainer.getShiftDigitalObject();
      if (fdEvents && typeof fdEvents.actionsOnHomePage === "function") {
        fdEvents.actionsOnHomePage("carousel scroll:right");
      }
      fireTagMediaInteractionEvent({
        action: "swipe right",
        mediaType: "slider",
        mediaLink: "",
        mediaName: "",
      });
    },

    // setting banner controls width according to count
    // setWidthForBannerControls() {
    //   let container = document.querySelector(".carousel-list-items");
    //   let slideCount = document.querySelectorAll(".slide-count");

    //   this.bannerControlsWidth = `${setWidth}px !important`;
    // },
  },
};
</script>
<style @scoped>
.carousel-list-items {
  position: absolute;
  bottom: 38px;
}

.slide-count {
  color: #fff;
  z-index: 1;
  min-width: 55px;
  text-align: center;
  font-size: 18px;
}

.slickActive .progress {
  background: none;
  margin: 0 auto;
  box-shadow: none;
  width: 38px;
  height: 38px;
  line-height: 38px;
  position: relative;
  top: 10px;
}

.slickActive .progress:after {
  content: "";
  border-radius: 50%;
  border: 3px solid #f2f5f5;
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
}

.slickActive .progress > span {
  position: absolute;
  top: 0;
  z-index: 1;
  width: 50%;
  height: 100%;
  overflow: hidden;
}

.slickActive .progress .progress-left {
  left: 0;
}

.slickActive .progress .progress-bar {
  border-width: 3px;
  border-style: solid;
  position: absolute;
  width: 100%;
  height: 100%;
  background: none;
  top: 0;
}

.slickActive .progress .progress-left .progress-bar {
  left: 100%;
  border-top-right-radius: 80px;
  border-bottom-right-radius: 80px;
  border-left: 0;
  -webkit-transform-origin: center left;
  transform-origin: center left;
}

.slickActive .progress .progress-right {
  right: 0px;
}

.slickActive .progress .progress-right .progress-bar {
  left: -100%;
  -webkit-transform-origin: center right;
  transform-origin: center right;
  border-top-left-radius: 80px;
  border-bottom-left-radius: 80px;
  border-right: 0;
}

.slickActive .progress .progress-value {
  font-size: 8px;
  color: rgb(250, 245, 245);
  text-align: center;
  width: 100%;
  height: 100%;
  position: absolute;
}

@keyframes loading-1 {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg);
  }

  100% {
    -webkit-transform: rotate(180deg);
    transform: rotate(180deg);
  }
}

@keyframes loading-2 {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg);
  }

  100% {
    -webkit-transform: rotate(144deg);
    transform: rotate(180deg);
  }
}

.slickActive .progress.blue .progress-bar {
  border-color: var(--bg-color);
}

.banner-view-details {
  bottom: 65px;
  right: 85px;
}

#rotaional-carousel #btn-details.banner-view-details-top {
  top: -2px;
  font-size: 18px !important;
  width: 100%;
  padding: 12px 0px !important;
}

.inventorynew-iframe .banner-view-details,
.inventoryvdp-iframe .banner-view-details {
  bottom: 10px !important;
}

.inventorynew-iframe .hide-controls-enabled,
.inventoryvdp-iframe .hide-controls-enabled {
  bottom: 8px !important;
}

.inventorynew-iframe .VueCarousel-pagination,
.inventoryvdp-iframe .VueCarousel-pagination {
  margin-top: unset !important;
}

.width-50 {
  width: 50%;
}

.VueCarousel-navigation-button:focus {
  outline: none !important;
}

.VueCarousel-navigation-prev {
  left: 3% !important;
}

.VueCarousel-navigation-next {
  right: 3% !important;
}

.VueCarousel-pagination {
  margin-top: -60px;
  z-index: 99;
  display: none;
}

.VueCarousel-dot[data-v-438fd353]:focus {
  outline: none;
}

.VueCarousel-dot-container button.VueCarousel-dot {
  border-radius: 50% !important;
  width: 8px !important;
  height: 8px !important;
  background-color: #cccccc !important;
  opacity: 1;
  margin: 0 5px !important;
  padding: 0px !important;
}

.VueCarousel-dot-container button.VueCarousel-dot--active {
  background-color: transparent !important;
  width: 12px !important;
  height: 12px !important;
  border: 2px solid #fff !important;
}

#rotaional-carousel .banner-view-details-top {
  max-width: 15%;
  right: 30px !important;
  top: 20px !important;
}

@media (min-width: 992px) {
  .VueCarousel-pagination {
    width: 500px !important;
    margin-left: auto;
    margin-right: auto;
  }
}

@media (min-width: 992px) and (max-width: 1200px) {
  .banner-view-details {
    bottom: 65px;
    right: 85px;
  }

  .inventorynew-iframe .banner-view-details,
  .inventoryvdp-iframe .banner-view-details {
    bottom: 10px !important;
  }

  .inventorynew-iframe .hide-controls-enabled,
  .inventoryvdp-iframe .hide-controls-enabled {
    bottom: 8px !important;
  }
}

@media (max-width: 767px) {
  .rotational-banner-component {
    min-height: 10px;
  }

  #rotaional-carousel a#btn-details.btn-view-details {
    font-size: 10px !important;
    padding: 5px 6px !important;
  }

  .VueCarousel-navigation-prev {
    left: 10% !important;
  }

  .VueCarousel-navigation-next {
    right: 10% !important;
  }

  .lux-main-banner .banner-view-details {
    bottom: 67px !important;
  }

  .banner-view-details {
    bottom: 45px;
    right: 10px;
    font-size: 8px;
  }

  #rotaional-carousel #btn-details.banner-view-details-top {
    top: -2px;
    font-size: 8px !important;
    width: 100%;
    padding: 12px 0px !important;
  }

  .inventorynew-iframe .banner-view-details,
  .inventoryvdp-iframe .banner-view-details {
    bottom: 8px !important;
  }

  .VueCarousel-pagination {
    z-index: 98;
  }

  .carousel-list-items {
    bottom: 35px;
    position: static;
  }

  .slide-count {
    min-width: 45px;
    color: #262626;
  }

  .slickActive .progress.blue .progress-bar {
    border-color: #262626;
  }

  .slickActive .progress:after {
    border: 3px solid #e2e2e2;
  }

  .animation-wrapper {
    text-align: center;
  }

  .slickActive .progress .progress-value {
    color: #262626;
  }
}

@media (max-width: 780px) {
  .bw-rotational-banner .VueCarousel-pagination {
    display: none;
  }

  .VueCarousel-navigation-prev,
  .VueCarousel-navigation-next {
    display: none;
  }

  .VueCarousel-pagination {
    margin-top: 0px;
    top: unset !important;
    bottom: 20px;
    position: absolute !important;
  }
}

@media (max-width: 480px) {
  .slide-count {
    min-width: 35px;
  }
}

.rotational-banner-component .arrow-fire.primaryicon-left-arrow:active {
  background-color: inherit !important;
}

.banner-wrapper:hover {
  text-decoration: none;
}
</style>

<style>
#rotaional-carousel section {
  text-align: left !important;
}
</style>
